<!-- @format -->

@if (education) {
  <ng-container>
    <div class="row">
      <div class="col-12 col-md-6">
        <h5 class="fudis-heading__md" translate>PROFILE.BASIC_INFO</h5>
        <sis-description-list [columnCount]="1">
          <dl>
            <ng-template #listItem>
              <dt class="sis-label">{{ "PROFILE.VALID" | translate }}</dt>
              <dd>{{ studyRight.valid | localDateRange }}</dd>
            </ng-template>
            @if (studyRight.studyRightExtensions?.length) {
              <ng-template #listItem>
                <dt class="sis-label">{{ "PROFILE.GRANTED_EXTENSIONS" | translate }}</dt>
                <dd>
                  <sis-extension-info
                    [extensions]="studyRight.studyRightExtensions"
                    [showShowDetails]="true"
                    (showDetails)="openExtensionDetails($event)" />
                </dd>
              </ng-template>
            }
            <ng-template #listItem>
              <dt class="sis-label">{{ "PROFILE.ORGANISATION" | translate }}</dt>
              <dd>{{ (studyRight.organisationId | organisation | async)?.name | localizedString }}</dd>
            </ng-template>
            <ng-template #listItem>
              <dt class="sis-label">{{
                "STUDENT_APPLICATIONS.DEGREE_PROGRAMME_ATTAINMENT_APPLICATION.PERSON_INFO.SCHOOL_EDUCATION_LANGUAGE" | translate
              }}</dt>
              @if (studyRight?.schoolEducationLanguageUrn) {
                <dd>
                  {{ studyRight?.schoolEducationLanguageUrn | codeLocalizedName | async }}
                </dd>
              }
              @if (isStaffUser && !studyRight?.schoolEducationLanguageUrn) {
                <dd>
                  {{ "PROFILE.INFO_NOT_GIVEN_CAN_BE_FILLED" | translate }}
                  <a
                    fudisLink
                    [href]="'/tutor/role/staff/student/' + studyRight.studentId + '/basic/study-rights'"
                    [external]="true"
                    [title]="'PROFILE.STUDY_RIGHT_BASIC_INFO' | translate"></a>
                </dd>
              }
            </ng-template>
          </dl>
        </sis-description-list>
        <div class="row sis-mb-lg">
          <div class="col-12 col-md-6">
            <sis-expandable
              [variant]="'link'"
              [title]="'PROFILE.SHOW_DETAILS' | translate"
              [level]="6"
              [attr.aria-label]="('ARIA_LABEL.SHOW_DETAILS' | translate) + ' ' + (education.name | localizedString)">
              <ng-template sisExpandableContent>
                <sis-description-list [columnCount]="1">
                  <dl>
                    <ng-template #listItem>
                      <dt class="sis-label">{{ "PROFILE.EXPIRATION_RULES" | translate }}</dt>
                      <dd>{{ studyRight.studyRightExpirationRulesUrn | codeLocalizedName | async }}</dd>
                    </ng-template>
                    @if (studyRight.decreeOnUniversityDegreesUrn) {
                      <ng-template #listItem>
                        <dt class="sis-label">{{ "PROFILE.DECREE_ON_UNIVERSITY_DEGREES" | translate }}</dt>
                        <dd>{{ studyRight.decreeOnUniversityDegreesUrn | codeLocalizedName | async }}</dd>
                      </ng-template>
                    }
                    @if (studyRight.degreeRegulations) {
                      <ng-template #listItem>
                        <dt class="sis-label">{{ "PROFILE.DEGREE_REGULATIONS" | translate }}</dt>
                        <dd>{{ studyRight.degreeRegulations }}</dd>
                      </ng-template>
                    }
                    <ng-template #listItem>
                      <dt class="sis-label">{{ "PROFILE.GRANT_DATE" | translate }}</dt>
                      <dd>{{ studyRight.grantDate | localDateFormat }}</dd>
                    </ng-template>
                    @if (studyRight.studyStartDate) {
                      <ng-template #listItem>
                        <dt class="sis-label">{{ "PROFILE.START_DATE" | translate }}</dt>
                        <dd>{{ studyRight.studyStartDate | localDateFormat }}</dd>
                      </ng-template>
                    }
                    @if (studyRight.alternativeStudyStartDate) {
                      <ng-template #listItem>
                        <dt class="sis-label">{{ "PROFILE.ALTERNATIVE_STUDY_START_DATE" | translate }}</dt>
                        <dd>{{ studyRight.alternativeStudyStartDate | localDateFormat }}</dd>
                      </ng-template>
                    }
                    @if (studyRight.transferOutDate) {
                      <ng-template #listItem>
                        <dt class="sis-label">{{ "PROFILE.TRANSFER_OUT_DATE" | translate }}</dt>
                        <dd>{{ studyRight.transferOutDate | localDateFormat }}</dd>
                      </ng-template>
                    }
                    @if (education | isAgreementStudy) {
                      <ng-template #listItem>
                        <dt class="sis-label">{{ "PROFILE.HOME_ORGANISATION" | translate }}</dt>
                        <dd>{{ studyRight.homeOrganisationUrn | codeLocalizedName | async }}</dd>
                      </ng-template>
                    }
                  </dl>
                </sis-description-list>
                @if (studyRight.codeUrns) {
                  <sis-custom-code-urns [codeUrns]="studyRight.codeUrns" [classificationScope]="'study-right'" />
                }
              </ng-template>
            </sis-expandable>
          </div>
        </div>

        @if (studyRight && hasMobilityPeriodForStudyRight) {
          <div class="row">
            <div class="col-12">
              <h5 class="fudis-heading__md" translate>{{
                "MOBILITY_PERIOD." + ((education | isDegreeEducation) ? "OUT" : "IN") + "BOUND_STUDENT.TITLE"
              }}</h5>
              <sis-mobility-periods [studyRightId]="studyRight.id" [education]="education" />
            </div>
          </div>
        }
      </div>

      <div class="col-12 col-md-6">
        <div class="row sis-mb-lg">
          <div class="col-12">
            <sis-study-right-states
              [studyRightId]="studyRight.id"
              [studyRightCancellation]="studyRight.studyRightCancellation"
              [studyRightPassivations]="studyRight.studyRightPassivations" />
          </div>
        </div>
        @if (alwaysDisplayDegreeProgrammeAttainments || hasDegreeProgrammeAttainments || isRegistrationRequired) {
          <ng-container>
            <div class="row sis-mb-lg">
              <div class="col-12">
                <h5 class="fudis-heading__md" translate>PROFILE.STUDY_PROGRESS</h5>
                @if (attainments) {
                  <sis-attained-degrees [studyRightId]="studyRight.id" [attainments]="attainments" />
                }
                @if (isRegistrationRequired) {
                  <sis-semesters-indicator [studyRightId]="studyRight.id" />
                }
              </div>
            </div>
            @if (isRegistrationRequired) {
              <div class="row sis-mb-lg">
                <div class="col-12">
                  <h5 class="fudis-heading__md" translate>PROFILE.ATTENDANCE</h5>
                  <sis-study-years-term-registrations [studyRightId]="studyRight.id" />
                </div>
              </div>
            }
          </ng-container>
        }
      </div>
    </div>

    <sis-readonly-tuition-fee-periods [studyRightId]="studyRight.id" />

    <div class="row">
      <div class="col-12">
        <hr class="sis-hr sis-mb-lg" aria-hidden="true" />
        <h5 class="fudis-heading__md" id="study-path-title-{{ studyRight.id }}" #studyPathTitle tabindex="-1" translate>
          PROFILE.STUDY_PATH.TITLE
        </h5>
        <div class="sis-mb-sm">
          <sis-personalized-selection-notification [education]="education" [studyRight]="studyRight" />
        </div>
        <div class="row sis-mb-lg">
          <div class="col-12">
            <sis-description-list>
              <dl>
                <ng-template #listItem>
                  <dt class="sis-label">{{ "PROFILE.LEARNING_OPPORTUNITY" | translate }}</dt>
                  <dd>{{ studyRight.learningOpportunityId | learningOpportunityName: education | localizedString }}</dd>
                </ng-template>
              </dl>
            </sis-description-list>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-5">
            <sis-basic-grouping-panel
              [level]="6"
              [heading]="('PROFILE.STUDY_PATH.PHASE_1' | translate) + ' ' + (education.structure.phase1.name | localizedString)">
              <sis-description-list>
                <dl>
                  @if (education | isDegreeEducation) {
                    <ng-template #listItem>
                      <dt class="sis-label">{{ "PROFILE.STUDY_PATH.EDUCATION_CLASSIFICATION" | translate }}</dt>
                      <dd>{{ studyRight.phase1EducationClassificationUrn | codeLocalizedName | async }}</dd>
                    </ng-template>
                  }
                  <ng-template #listItem>
                    <dt class="sis-label">{{ "PROFILE.STUDY_PATH.EDUCATION_LOCATION" | translate }}</dt>
                    <dd>{{ studyRight.phase1EducationLocationUrn | codeLocalizedName | async }}</dd>
                  </ng-template>
                </dl>
              </sis-description-list>
            </sis-basic-grouping-panel>
          </div>
          @if (education.structure.phase2) {
            <div class="col-12 col-md-5 offset-md-1">
              <sis-basic-grouping-panel
                [level]="6"
                [heading]="('PROFILE.STUDY_PATH.PHASE_2' | translate) + ' ' + (education.structure.phase2.name | localizedString)">
                <sis-description-list>
                  <dl>
                    @if (education | isDegreeEducation) {
                      <ng-template #listItem>
                        <dt class="sis-label">{{ "PROFILE.STUDY_PATH.EDUCATION_CLASSIFICATION" | translate }}</dt>
                        <dd>{{ studyRight.phase2EducationClassificationUrn | codeLocalizedName | async }}</dd>
                      </ng-template>
                    }
                    <ng-template #listItem>
                      <dt class="sis-label">{{ "PROFILE.STUDY_PATH.EDUCATION_LOCATION" | translate }}</dt>
                      <dd>{{ studyRight.phase2EducationLocationUrn | codeLocalizedName | async }}</dd>
                    </ng-template>
                  </dl>
                </sis-description-list>
              </sis-basic-grouping-panel>
            </div>
          }
        </div>
        <div class="row sis-mb-lg">
          @if (studyRight.phase1InternationalContractualDegree) {
            <div class="col-12 col-md-5">
              <sis-basic-grouping-panel
                [level]="6"
                [heading]="('PROFILE.STUDY_PATH.PHASE_1' | translate) + ' ' + (education.structure.phase1.name | localizedString)">
                <sis-international-contractual-degree [internationalContractualDegree]="studyRight.phase1InternationalContractualDegree" />
              </sis-basic-grouping-panel>
            </div>
          }
          @if (studyRight.phase2InternationalContractualDegree) {
            <div class="col-12 col-md-5" [class.offset-md-1]="studyRight.phase1InternationalContractualDegree">
              <sis-basic-grouping-panel
                [level]="6"
                [heading]="('PROFILE.STUDY_PATH.PHASE_2' | translate) + ' ' + (education.structure.phase2.name | localizedString)">
                <sis-international-contractual-degree [internationalContractualDegree]="studyRight.phase2InternationalContractualDegree" />
              </sis-basic-grouping-panel>
            </div>
          }
        </div>
        <sis-study-right-education-structure-view [education]="education" [studyRight]="studyRight" [attainments]="attainments" />

        @if (attainmentsByModuleGroupId && (education | isDegreeEducation)) {
          <sis-minor-selections
            [attainmentsByModuleGroupId]="attainmentsByModuleGroupId"
            [studyRight]="studyRight"
            [education]="education" />
        }

        @if (studyRight.moduleSelections?.length || studyRight.courseUnitSelections?.length) {
          <hr class="sis-hr sis-mb-lg" aria-hidden="true" />
        }

        @if (studyRight.moduleSelections?.length) {
          <ng-container>
            <h5 class="fudis-heading__md sis-pb-xxs" translate>PROFILE.STUDY_RIGHT_SELECTIONS.MODULE_SELECTIONS_TITLE</h5>
            <div class="row d-block sis-mb-lg">
              @for (moduleSelection of studyRight.moduleSelections; track moduleSelection) {
                <div class="col-12 col-md-4 sis-mb-xs">
                  <sis-module-selection
                    [selection]="moduleSelection"
                    [attainment]="attainmentsByModuleGroupId[moduleSelection.moduleGroupId]" />
                </div>
              }
            </div>
          </ng-container>
        }
        @if (studyRight.courseUnitSelections?.length) {
          <ng-container>
            <h5 class="sis-pb-xxs" translate>PROFILE.STUDY_RIGHT_SELECTIONS.COURSE_UNIT_SELECTIONS_TITLE</h5>
            <div class="row d-block sis-mb-lg">
              @for (courseUnitSelection of studyRight.courseUnitSelections; track courseUnitSelection) {
                <div class="col-12 col-md-4 sis-mb-xs">
                  <sis-course-unit-selection
                    [selection]="courseUnitSelection"
                    [attainment]="attainmentsByCourseUnitGroupId[courseUnitSelection.courseUnitGroupId]" />
                </div>
              }
            </div>
          </ng-container>
        }

        <hr class="sis-hr sis-mb-lg" aria-hidden="true" />

        <h5 class="fudis-heading__md">{{ "PROFILE.STUDY_RIGHT_SELECTIONS.COOPERATION_NETWORK_RIGHTS.TITLE" | transloco }}</h5>
        <div class="row">
          <div class="col-10">
            @if (studyRight.cooperationNetworkRights?.length) {
              <table class="table styled-table">
                <caption>{{ "PROFILE.STUDY_RIGHT_SELECTIONS.COOPERATION_NETWORK_RIGHTS.SUB_TITLE" | transloco }}</caption>
                <thead>
                  <tr>
                    <th>{{ "PROFILE.STUDY_RIGHT_SELECTIONS.COOPERATION_NETWORK_RIGHTS.ABBREVIATION" | transloco }}</th>
                    <th>{{ "PROFILE.STUDY_RIGHT_SELECTIONS.COOPERATION_NETWORK_RIGHTS.NAME" | transloco }}</th>
                    <th>{{ "PROFILE.STUDY_RIGHT_SELECTIONS.COOPERATION_NETWORK_RIGHTS.VALIDITY_PERIOD" | transloco }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (cooperationNetworkRight of studyRight.cooperationNetworkRights; track cooperationNetworkRight) {
                    <tr>
                      <td class="col-3">{{ (cooperationNetworkRight.cooperationNetworkId | cooperationNetwork | async)?.abbreviation }}</td>
                      <td class="col-3">{{
                        (cooperationNetworkRight.cooperationNetworkId | cooperationNetwork | async)?.name | localizedString
                      }}</td>
                      <td class="col-3">{{ cooperationNetworkRight.validityPeriod | localDateRange }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <p class="sis-guidance">
                {{ "PROFILE.STUDY_RIGHT_SELECTIONS.COOPERATION_NETWORK_RIGHTS.NO_NETWORKS" | transloco }}
              </p>
            }
          </div>
        </div>
      </div>
    </div>
  </ng-container>
}
